import { withHighlightPlugin } from '../../DolEditor/elements/highlight/withHighlightPlugin';
import { withHyperLinkPlugin } from '../../DolEditor/elements/hyper-link/withHyperLinkPlugin';
import { withRoundedPlugin } from '../../DolEditor/elements/rounded/withRoundedPlugin';
import { withTableV2 } from '../../DolEditor/elements/table-blog/components/AdminView/withTableV2';
import { withVocabCardPlugin } from '../../DolEditor/elements/vocab-card/renderElement';
import { withBreakLinePlugin } from '../../DolEditor/handlers/break-line-no-style/withBreakLine';
import { PluginPresetEnum } from '../BlogEditor.types';
import { withBlankV2 } from '../plugins-common/BlankV2/withBlankV2';
import { withParagraphToggle } from '../plugins-common/ParagraphToggle/withParagraphToggle';
import { withBulletPointPluginEditorChain } from '../plugins/BulletPoint/BulletPointPlugin';
import { withCardLogicPluginEditorChain } from '../plugins/CardLogic/CardLogicPlugin';
import { withDivEditorChains } from '../plugins/DivPlugin';
import { withMultipleChoiceCorrectOption } from '../plugins/ExerciseMultipleChoice/withMultipleChoiceCorrectOption';
import { withShortAnswer } from '../plugins/ExerciseShortAnswer/withShortAnswer';
import { withQuestionStyleEditorChain } from '../plugins/QuestionStyle/QuestionStyle';
import { withQuotePluginEditorChain } from '../plugins/Quote/QuotePlugin';
import { withImageSlideTextEditorChain } from '../plugins/SpecialObject/ImageSlide/SlideText/ImageSlideTextPlugin';
import { withDeleteAtEndNode } from '../plugins/withDeleteAtEndNode';
import { withParagraphAtEditorEnd } from '../plugins/withParagraphAtEditorEnd';
import { withInlineVoid } from '../../../slatePlugins/plugins/inline-void/withInlineVoid';
import { withDeserializeHTML } from '../../DolEditor/deserializers/html-deserializer/withDeserializeHTML';
import { withNodeId } from '../../DolEditor/withNodeId';

export const useGetAdminEditorChains = ({
  extraEditorChains = [],
  plugins,
  isReadOnly = false,
  presets,
}) => {
  return [
    withNodeId(),
    // core
    withInlineVoid({ plugins }),
    withDeserializeHTML({ plugins }), // This must be above any plugins handle copy/paste ( so it won't add default html handling )
    ...extraEditorChains,
    withBreakLinePlugin(), // this must ahead of list plugin ( so it won't override insert break behavior of list )
    withDivEditorChains(),
    withDeleteAtEndNode(),
    !isReadOnly &&
      presets.includes(PluginPresetEnum.CORE_PARAGRAPH_AT_END) &&
      withParagraphAtEditorEnd(),
    // text format (leaf)
    (presets.includes(PluginPresetEnum.HYPER_LINK) ||
      presets.includes(PluginPresetEnum.TEXT_FORMAT)) &&
      withHyperLinkPlugin({ isReadOnly }),
    presets.includes(PluginPresetEnum.TEXT_FORMAT) && withHighlightPlugin(),
    presets.includes(PluginPresetEnum.TEXT_FORMAT) && withRoundedPlugin(),
    presets.includes(PluginPresetEnum.TEXT_FORMAT) && withQuestionStyleEditorChain(),
    // html object
    presets.includes(PluginPresetEnum.HTML_OBJECT) && withTableV2(),
    presets.includes(PluginPresetEnum.HTML_OBJECT) && withBulletPointPluginEditorChain(),
    // special object
    presets.includes(PluginPresetEnum.SPECIAL_OBJECT) && withCardLogicPluginEditorChain(),
    presets.includes(PluginPresetEnum.SPECIAL_OBJECT) && withImageSlideTextEditorChain(),
    presets.includes(PluginPresetEnum.SPECIAL_OBJECT) && withQuotePluginEditorChain(),
    presets.includes(PluginPresetEnum.SPECIAL_OBJECT) && withVocabCardPlugin(),
    // exercise object
    presets.includes(PluginPresetEnum.EXERCISE_OBJECT) && withShortAnswer(),
    presets.includes(PluginPresetEnum.EXERCISE_OBJECT) && withMultipleChoiceCorrectOption(),
    presets.includes(PluginPresetEnum.EXERCISE_OBJECT) && withParagraphToggle(),
    presets.includes(PluginPresetEnum.EXERCISE_OBJECT) && withBlankV2(),
  ].filter(Boolean);
};
